import {
  FETCH_KEYWORD_RESEARCH_IN_PROGRESS,
  FETCH_KEYWORD_RESEARCH_SUCCESSFUL,
  FETCH_KEYWORD_RESEARCH_FAILED,
  CHANGE_SELECTED_RESEARCH_TYPE
} from "./types";

export const fetchKeywordResearchInProgress = (keyword, researchType, seoDb) => ({
  type: FETCH_KEYWORD_RESEARCH_IN_PROGRESS,
  keyword,
  researchType,
  seoDb
});

export const fetchKeywordResearchSuccessful = (keyword, researchType, seoDb, result) => ({
  type: FETCH_KEYWORD_RESEARCH_SUCCESSFUL,
  keyword,
  researchType,
  seoDb,
  result
});

export const fetchKeywordResearchFailed = (keyword, researchType, seoDb) => ({
  type: FETCH_KEYWORD_RESEARCH_FAILED,
  keyword,
  researchType,
  seoDb
});

export const changeSelectedResearchType = researchType => ({
  type: CHANGE_SELECTED_RESEARCH_TYPE,
  researchType
});
